import isAllowedTariffForUser from './isAllowedTariffForUser';
import isPeriodDifferentByProducts from './isPeriodDifferentByProducts';

/**
 * Checks either "product" can be included via cross-selling as complimentary item to a "mainProduct".
 *
 * @param product
 * @param mainProduct
 * @param cart
 * @return {*}
 */
export default (product, mainProduct, cart) => {
    // Each function's result is assigned to dedicated variable for easier debugging.
    const isAllowedTariffForUserFlag = isAllowedTariffForUser({ tariff: product?.tariff, product, mainProduct, cart });
    const isPeriodDifferentByProductsFlag = !isPeriodDifferentByProducts(mainProduct, product);
    return !!product?.tariff
        && isAllowedTariffForUserFlag
        && isPeriodDifferentByProductsFlag;
}
